import React from "react";
import { Outlet, useLocation } from "react-router-dom";
import cn from "classnames";
import TreydoraHeader from "../layout/TreydoraHeader";
import SiteFooter from "./SiteFooter";
import "./site-shell.css";

/**
 * Global header + footer. Dashboard uses its own `GatewayTopNav`; omit shell header there to avoid duplicate nav.
 */
export default function TreydoraSiteShell() {
  const { pathname } = useLocation();
  const isDashboardRoute = pathname.startsWith("/dashboard");
  const showSiteHeader = !isDashboardRoute;
  const immersiveCommerce =
    pathname.startsWith("/marketplace") || pathname.startsWith("/item-detail");

  return (
    <div className="td-site">
      {showSiteHeader ? <TreydoraHeader /> : null}
      <main className={cn("td-site__main", immersiveCommerce && "td-site__main--immersive")}>
        <Outlet />
      </main>
      <SiteFooter />
    </div>
  );
}
